import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { getValueProperty, memoize, setValueProperty } from '../../shared/helpers/functions.helpers';
import { BaseComponent } from '../../shared/components/base-component';
import { ApplicationService, EApplication } from '../../shared/services/application/application.service';
import { LocalStorageService } from '../../shared/services/application/local-storage.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { EVENT } from '../../shared/constants/dali.constants';

@Component({
  selector: 'app-steps-information-modal',
  templateUrl: './steps-information-modal.component.html',
  styleUrls: ['./steps-information-modal.component.scss']
})
export class StepsInformationModalComponent extends BaseComponent implements OnInit {
  form: FormGroup = this.fb.group({
    'chkstepsmodal': new FormControl(true)
  });
  chkDisable: any;


  /**
 * Contiene los textos y etiquetas
 */
  CONTENT_BOUNDS: any[] | any;
  settings: any[] | any;
  loading: boolean = false;
  appCurrentApplication: any;
  stepsInformation: any;

  showCheckDisplayModal: boolean = true;
  visibleFiducialText: boolean = true;

  canCallCloseEvent = true;

  constructor(
    private readonly cps: CopyService,
    private readonly fb: FormBuilder,
    public readonly app: ApplicationService,
    private link: LinkupService,
    private storage: LocalStorageService
  ) {
    super(app, link, 'steps-information-modal')
  }

  ngOnInit(): void {
    this.loadStaticValues();
    setTimeout(() => {
      this.loadEvent();
    }, 1000);
  }

  onCloseModalCR(event: any) {
    if (this.canCallCloseEvent) {
      let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
      let events = [
        {
          "name": "{EVENT.pv1E5setData.pv1E5transactionName.path}",
          "value": EVENT.pv1E5setData.pv1E5transactionName.value
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
      this.chkDisable = false;
    }

    this.canCallCloseEvent = false;

    if (this.app.currentApplication == "fiducial") {
      let urlFiducialSteps = getValueProperty(this.CONTENT_BOUNDS, "modals.urlFiducialSteps", "https://itau.comforce.co/tareas/clientes/create");

      const a = document.createElement('a')
      a.href = urlFiducialSteps;
      a.target = '_blank';
      a.click();
      a.remove();
      this.app.currentApplication = EApplication.BANK;
    }
  }

  onOpenModalCR() {
    let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
        "name": "{EVENT.pv2E3setData.pv2E3transactionName.path}",
        "value": EVENT.pv2E3setData.pv2E3transactionName.value
      },
      {
        "name": "{EVENT.pv2E3setData.pv2E3transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ];
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
    this.chkDisable = true;
    this.showCheckDisplayModal = false;
  }

  async loadStaticValues() {
    this.loading = true;
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy("steps-information-modal");
    this.chkDisable = this.storage.getItem(this.app.channelId + "-" + this.app.currentApplication + "-statusmodal") ? false : true;
    if (this.app.currentApplication == "fiducial") {
      if (!this.chkDisable) {
        let urlFiducialSteps = getValueProperty(this.CONTENT_BOUNDS, "modals.urlFiducialSteps", "https://itau.comforce.co/tareas/clientes/create");

        const a = document.createElement('a')
        a.href = urlFiducialSteps;
        a.target = '_blank';
        a.click();
        a.remove();

        this.app.currentApplication = EApplication.BANK;
      }
    }
    let control = this.form.get('chkstepsmodal');
    control?.setValue(!this.chkDisable);
    this.stepsInformation = this.getSteps();
    this.loading = false;
    this.visibleFiducialText = this.app.currentApplication == "fiducial";
  }

  /**
   * Permite inicializar los campos del formulario en el componente
   */
  getSteps() {
    return this.getSetting("content_section", "steps", []);
  }

  get linkSetting() {
    return this.getSetting("link_section");
  }

  modalVisible() {
    let control = this.form.get('chkstepsmodal');
    if (getValueProperty(control, "value", false)) {
      this.storage.setItem(this.app.channelId + "-" + this.app.currentApplication + "-statusmodal", "true");
    }
    else {
      this.storage.removeItem(this.app.channelId + "-" + this.app.currentApplication + "-statusmodal");
    }
  }

  async loadEvent() {
    if (this.chkDisable) {

      let eventSetting = this.getSetting("analytics", "trackEvent.e6", "");
      let events = [
        {
          "name": "{EVENT.pv1E6setData.pv1E6transactionName.path}",
          "value": EVENT.pv1E6setData.pv1E6transactionName.value
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
  }

}
